import { forwardRef, useEffect, useRef, useState } from "react";
import { Button, Col, Row } from "react-bootstrap";
import WebService from "../../../Services/WebService";
import {
  FinanceDetails_INVESTORInterface,
  RegistrationIds,
} from "../../../assets/interface/primeSharkWebsite_interface";
import ErrorComponent from "../../Common/ErrorComponent";
import { toast } from "react-toastify";
import "react-tagsinput/react-tagsinput.css";
import CompoLoader from "../../ComponentLoader/CompoLoader";
import HelperService from "../../../Services/HelperService";
import { isDate } from "moment";
import { DROPDOWNTYPES } from "../../../assets/constants/constants";
import RequiredLabel from "../../Common/RequiredLabel/RequiredLabel";
import Select from "react-dropdown-select";
import {
  dropdownApiNewcall,
  getProfileJourneyInfo,
} from "../../../Services/CommonFunction";
import Select1 from "react-select";
import TagsInput from "react-tagsinput";
import CommonScrollbar from "../../Common/ScrollBar/CommonScrollbar";
import InfoIconForKeyword from "../../Common/info/infoIcon";
import SuccessPopup from "../SuccessPopup";
import { isWarning } from "../Helper";
import { useDispatch } from "react-redux";
import DatePicker from "react-datepicker";

interface PropsData {
  impIds: RegistrationIds;
  handleNext: any;
  from?: string;
  fields_to_improve?: any;
}
const types = [
  DROPDOWNTYPES.INVESTMENT_INSTRUMENTS,
  DROPDOWNTYPES.BUSINESS_MODEL,
  DROPDOWNTYPES.LEVEL_OF_INVOLVEMENT,
  DROPDOWNTYPES.TYPICAL_INVESTMENT_RANGE,
  DROPDOWNTYPES.INVESTMENT_INSTRUMENTS,
  DROPDOWNTYPES.TRAGET_DOMAINS,
  DROPDOWNTYPES.PREFERRED_INVESTMENT_STAGES,
  DROPDOWNTYPES.ASSOCIATED_WITH,
  DROPDOWNTYPES.PROFILE_VISIBILITY,
  DROPDOWNTYPES.INVESTMENT_AGE,
];
const GLOBAL_MARKET_OPTIONS = [
  { label: "Yes", value: "1" },
  { label: "No", value: "0" },
  { label: "On Request", value: "2" },
];
const FinanceDetails_INVESTOR = ({
  impIds,
  handleNext,
  from,
  fields_to_improve,
}: PropsData) => {
  const [financeDetails, setFinanceDetails] =
    useState<FinanceDetails_INVESTORInterface>({
      // investment_from_range: "",
      // investment_to_range: "",
      investment_age: "",
      financial_from_year: null,
      financial_to_year: "",
      business_models: [],
      investment_instruments: "",
      level_of_involvement: "",
      preferred_investment_stages: [],
      top_keywords: [],
      traget_domains: [],
      typical_investment_range: "",
      associated_with: "",
      global_market_support: "",
      open_syndicates: "",
      profile_visibility: "",
    });
  const [menuOpen4, setMenuOpen4] = useState(false);
  const [errorFlag, setErrorFlag] = useState(false);
  const [checked1, setChecked1] = useState(false);
  const [checked2, setChecked2] = useState(false);
  const [loader, setLoader] = useState(false);
  const [dropdownData, setDropdownData] = useState<Record<string, any[]>>({});
  const controlRef = useRef<HTMLDivElement | null>(null);
  const [show, setShow] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [apiCallTriggered, setAPICallTriggered] = useState(false);
  let dispatch = useDispatch();
  useEffect(() => {
    if (!menuOpen) return;
    const observer = new IntersectionObserver(
      (entries) => {
        const entry = entries[0];

        if (!entry.isIntersecting) {
          setMenuOpen(false);
        }
      },
      {
        root: null, // viewport
        threshold: 0, // even 1px visibility counts
      },
    );

    if (controlRef.current) {
      observer.observe(controlRef.current);
    }

    return () => observer.disconnect();
  }, [menuOpen]);
  useEffect(() => {
    if (from === "FROM_PROFILE_ANALYSIS") {
      setChecked1(true);
      setChecked2(true);
    }
  }, [from]);
  const [menuOpen1, setMenuOpen1] = useState(false);
  const controlRef1 = useRef<HTMLDivElement | null>(null);
  useEffect(() => {
    if (!menuOpen1) return;

    const observer = new IntersectionObserver(
      (entries) => {
        const entry = entries[0];

        if (!entry.isIntersecting) {
          setMenuOpen1(false);
        }
      },
      {
        root: null, // viewport
        threshold: 0, // even 1px visibility counts
      },
    );
    if (controlRef1.current) {
      observer.observe(controlRef1.current);
    }
    return () => observer.disconnect();
  }, [menuOpen1]);
  useEffect(() => {
    if (impIds?.business_uuid) {
      handleGetFinanceDetails();
    }
    loadDropdowns();
  }, []);

  async function loadDropdowns() {
    try {
      const res = await dropdownApiNewcall("investor", types); // types is an array of expected keys
      const formattedData: Record<string, { label: string; value: any }[]> = {};
      types.forEach((type) => {
        const items = res[type];
        if (Array.isArray(items)) {
          formattedData[type] = items.map((item) => ({
            label: item.title,
            value: item.title,
          }));
        }
      });

      setDropdownData(formattedData);
    } catch (error) { }
  }

  const handleGetFinanceDetails = () => {
    setLoader(true);
    WebService.getAPI({
      action: `get-business/investor/${impIds?.business_uuid}`,
      body: null,
      isShowError: true,
    })
      .then((res: any) => {
        setFinanceDetails((prevFinance: FinanceDetails_INVESTORInterface) => ({
          ...prevFinance,
          investment_age: res?.info?.investment_age,
          financial_from_year: res?.info?.financial_from_year,
          financial_to_year: res?.info?.financial_to_year,
          business_models: res?.info?.business_models,
          preferred_investment_stages:
            res?.info?.preferred_investment_stages ?? [],
          level_of_involvement: res?.info?.level_of_involvement,
          typical_investment_range: res?.info?.typical_investment_range,
          investment_instruments: res?.info?.investment_instruments,
          associated_with: res?.info?.associated_with,
          traget_domains: res?.info?.traget_domains ?? [],
          profile_visibility: res?.info?.profile_visibility,
          top_keywords: res?.info?.top_keywords,
          open_syndicates:
            res?.info?.open_syndicates === 1
              ? "1"
              : res?.info?.open_syndicates === 0
                ? "0"
                : null,
          global_market_support:
            res?.info?.global_market_support === 0
              ? "0"
              : res?.info?.global_market_support === 1
                ? "1"
                : res?.info?.global_market_support === 2
                  ? "2"
                  : null,
        }));
      })

      .catch((error: any) => {
        return false;
      })
      .finally(() => {
        setLoader(false);
      });
  };

  const handleContinue = (flag: boolean) => {
    let f1 = isDate(financeDetails?.financial_from_year)
      ? financeDetails?.financial_from_year?.getFullYear()
      : financeDetails?.financial_from_year;
    let f2 = isDate(financeDetails?.financial_to_year)
      ? financeDetails?.financial_to_year?.getFullYear()
      : financeDetails?.financial_to_year;
    // let f2 = isDate(financeDetails?.financial_to_year)
    //   ? financeDetails?.financial_to_year?.getFullYear()
    //   : financeDetails?.financial_to_year;

    if (
      (!checked1 && from !== "REVIEW") ||
      (!checked2 && from !== "REVIEW") ||
      HelperService?.checkFormEmptyFields(financeDetails, [
        "financial_to_year",
        "financial_from_year",
        "business_models",
        "preferred_investment_stages",
        "level_of_involvement",
        "typical_investment_range",
        "preferred_investment_stages",
        "top_keywords",
        "traget_domains",
        "typical_investment_range",
        "associated_with",
        "global_market_support",
        "open_syndicates",
        "profile_visibility",
        "investment_age",
        "investment_instruments",
      ])
    ) {
      setErrorFlag(true);
      return;
    } else {
      setErrorFlag(false);

      let obj: any = {
        ...financeDetails,
        financial_from_year: f1 ?? null,
        financial_to_year: f2 ?? null,
        investment_age: financeDetails?.investment_age,
        open_syndicates:
          financeDetails?.open_syndicates === "1"
            ? "1"
            : financeDetails?.open_syndicates === "0"
              ? "0"
              : null,
        global_market_support:
          financeDetails?.global_market_support === "1"
            ? "1"
            : financeDetails?.global_market_support === "0"
              ? "0"
              : financeDetails?.global_market_support === "2"
                ? "2"
                : null,
        // investment_from_range: financeDetails?.investment_from_range,
        // investment_to_range: financeDetails?.investment_to_range,
      };
      setErrorFlag(false);
      handleSaveFinanceDetailApiCall(obj, flag);
    }
  };
  const handleSaveFinanceDetailApiCall = (obj: any, flag: boolean) => {
    if (flag) WebService.addLoader("skip_finance_details");
    else WebService.addLoader("save_finance_details");
    setAPICallTriggered(true);
    return WebService.putAPI({
      action: `set-finance/investor/${impIds?.business_uuid}`,
      body: obj,
      isShowError: false,
    })
      .then((res: any) => {
        if (res?.status) {
          setShow(true);
          if (from === "REVIEW" || from === "FROM_PROFILE_ANALYSIS") {
            getProfileJourneyInfo(
              impIds?.login_type?.toLocaleLowerCase(),
              impIds?.business_uuid,
              dispatch,
            );
          }
          handleNext(res);
        } else {
          toast.error(res.message);
        }
      })
      .catch((error: any) => {
        toast.error(error?.response?.data?.message);
        return error;
      })
      .finally(() => {
        if (flag) WebService.removeLoader("skip_finance_details");
        else WebService.removeLoader("save_finance_details");
        setAPICallTriggered(false);
      });
  };

  const handleChangeCurrency = (type: string, value: any) => {
    setFinanceDetails(
      (prevBusinessDetails: FinanceDetails_INVESTORInterface) => ({
        ...prevBusinessDetails,
        [type]: value,
      }),
    );
  };
  const handleArrayValueChange = (value: any[], key: string) => {
    setFinanceDetails((prevDetails: FinanceDetails_INVESTORInterface) => ({
      ...prevDetails,
      [key]: Array.isArray(
        prevDetails[key as keyof FinanceDetails_INVESTORInterface],
      )
        ? value.map((item) => ({ title: item?.value }))
        : value[0]?.value,
    }));
  };

  const FinancialYearInput = forwardRef<
    HTMLInputElement,
    {
      value?: string;
      onClick?: () => void;
      fromYear?: string | undefined | null;
      toYear?: string | undefined | null;
    }
  >(({ onClick, fromYear, toYear }, ref) => (
    <input
      ref={ref}
      onClick={onClick}
      value={fromYear ? `${fromYear}-${toYear}` : ""}
      readOnly
      className="form-control"
    />
  ));

  FinancialYearInput.displayName = "FinancialYearInput";
  return (
    <>
      <div className="login-form w-100 position-relative ">
        {loader ? <CompoLoader /> : null}
        <h4>Finance</h4>
        <p>Please finance details</p>
        <CommonScrollbar height={"62vh"}>
          <div className="me-3">
            <Row>
              <Col lg={6} className="mb-2">
                <RequiredLabel isRequired={false}>
                  Financial Year(Want To Start)
                </RequiredLabel>
                {/* <Calender
                className={
                  isWarning(fields_to_improve, "financial_from_year")
                    ? "warning-field"
                    : ""
                }
                value={financeDetails.financial_from_year}
                setValue={(value: Date | null) => {
                  if (!value) {
                    setFinanceDetails(
                      (prev: FinanceDetails_INVESTORInterface) => ({
                        ...prev,
                        financial_from_year: null,
                        financial_to_year: "",
                      }),
                    );
                    return;
                  }

                  const fromYear = value.getFullYear();
                  const toYear = new Date(value);
                  toYear.setFullYear(fromYear + 1);

                  setFinanceDetails(
                    (prev: FinanceDetails_INVESTORInterface) => ({
                      ...prev,
                      financial_from_year: value,
                      financial_to_year: toYear?.getFullYear().toString(),
                    }),
                  );
                }}
              /> */}
                <DatePicker
                  selected={
                    financeDetails.financial_from_year
                      ? new Date(financeDetails.financial_from_year)
                      : null
                  }
                  onChange={(date: Date | null) => {
                    if (!date) {
                      setFinanceDetails((prev: any) => ({
                        ...prev,
                        financial_from_year: "",
                        financial_to_year: "",
                      }));
                      return;
                    }

                    setFinanceDetails((prev: any) => ({
                      ...prev,
                      financial_from_year: `${date.getFullYear()}`,
                      financial_to_year: `${date.getFullYear() + 1}`,
                    }));
                  }}
                  showYearPicker
                  dateFormat="yyyy"
                  customInput={
                    <FinancialYearInput
                      fromYear={financeDetails.financial_from_year ?? ""}
                      toYear={financeDetails.financial_to_year ?? ""}
                    />
                  }
                />

                {/* <ErrorComponent
                title="Please select financial year"
                flag={errorFlag}
                isArray={false}
                data={financeDetails?.financial_from_year}
              /> */}
              </Col>
              {/* <Col lg={6} className="mb-2">
              <div>To</div>
            
              <Form.Control
                type="text"
                placeholder="To"
                name="financial_to_year"
                value={financeDetails?.financial_to_year}
                onChange={(e: any) => { }}
              /> */}
              {/* <ErrorComponent
            title="Please enter financial to year"
            flag={errorFlag}
            isArray={false}
            data={financeDetails?.financial_to_year}
          /> */}
              {/* </Col> */}
              {/* <Col lg={6} className="mb-2" className="mb-2">
          <div>
            <label>Investment Range</label>

            <CurrencyInputField
              placeHolder="From"
              id="investment_from_range"
              prefix="$"
              suffix=""
              value={financeDetails?.investment_from_range}
              setValue={(value: string) => {
                handleChangeCurrency("investment_from_range", value);
              }}
            />

            <ErrorComponent
              title="Please enter investment from range"
              flag={errorFlag}
              isArray={false}
              data={financeDetails?.investment_from_range}
            />
          </div>
        </Col>

        <Col lg={6} className="mb-2" className="mb-2">
          <div className="">
            <label></label>
            <CurrencyInputField
              placeHolder="To"
              id="investment_to_range"
              prefix="$"
              suffix=""
              value={financeDetails?.investment_to_range}
              setValue={(value: string) => {
                handleChangeCurrency("investment_to_range", value);
              }}
            />

            <ErrorComponent
              title="Please enter investment to range"
              flag={errorFlag}
              isArray={false}
              data={financeDetails?.investment_to_range}
            />
          </div>
        </Col> */}
              <Col lg={6} className="mb-2">
                <RequiredLabel isRequired={false}>
                  Preferred Investment Age (years)
                </RequiredLabel>
                <Select
                  dropdownHeight="200px"
                  dropdownPosition="bottom"
                  className={
                    isWarning(fields_to_improve, "investment_age")
                      ? "warning-field"
                      : ""
                  }
                  options={dropdownData[DROPDOWNTYPES.INVESTMENT_AGE] || []}
                  onChange={(values: any) => {
                    // if (values?.length > 0) {
                    handleArrayValueChange(values, "investment_age");
                    // }
                  }}
                  labelField="label"
                  valueField="value"
                  name="investment_age"
                  values={
                    financeDetails.investment_age
                      ? [
                        {
                          value: financeDetails.investment_age,
                          label: financeDetails.investment_age,
                        },
                      ]
                      : []
                  }
                />
                {/* <Form.Control
                      type="text"
                      placeholder="Enter investment experience"
                      name="investment_experience"
                      value={basicDetails?.investment_experience}
                      onChange={(e) => handleChange(e?.target?.name, e?.target?.value)}
                      onKeyDown={(e) => {
                        if (
                          !/^\d$/.test(e.key) &&
                          e.key.length === 1 &&
                          !e.ctrlKey &&
                          !e.metaKey
                        ) {
                          e.preventDefault();
                        }
                      }}
                    /> */}
                {/* {errorFlag && !basicDetails?.investment_experience && (
                      <Label title="Please enter investment experience" modeError={true} />
                    )} */}
              </Col>
              {/* <div className="">
                <label>Preferred Investment Age(years)</label>
                <Form.Control
                  type="text"
                  placeholder="Enter preferred investment age"
                  name="investment_age"
                  value={financeDetails?.investment_age}
                  onChange={(e: any) => {
                    setFinanceDetails(
                      (
                        prevBusinessDetails: FinanceDetails_INVESTORInterface
                      ) => ({
                        ...prevBusinessDetails,
                        investment_age: e?.target?.value,
                      })
                    );
                  }}
                />


              </div> */}
              <Col>
                <RequiredLabel isRequired={false} infoMultiple={true}>
                  Preferred Business Model
                </RequiredLabel>
                <div className="mb-2 w-100">
                  <Select1
                    classNamePrefix="react-select"
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 999999 }),
                    }}
                    className={
                      isWarning(fields_to_improve, "business_model")
                        ? "warning-field"
                        : ""
                    }
                    isMulti
                    menuPortalTarget={document.body}
                    menuIsOpen={menuOpen4}
                    onMenuOpen={() => setMenuOpen4(true)}
                    onMenuClose={() => setMenuOpen4(false)}
                    closeMenuOnScroll={false}
                    menuPosition="fixed"
                    options={dropdownData[DROPDOWNTYPES.BUSINESS_MODEL] || []}
                    onChange={(values: any) => {
                      handleArrayValueChange(values || [], "business_models");
                    }}
                    // labelField="label"
                    // valueField="value"
                    name="business_models"
                    value={
                      financeDetails?.business_models?.length > 0
                        ? financeDetails?.business_models.map((item: any) => ({
                          value: item?.title,
                          label: item?.title,
                        }))
                        : []
                    }
                  />
                  {/* 
                <ErrorComponent
                  title="Please select business models"
                  flag={errorFlag}
                  isArray={true}
                  data={financeDetails?.business_models}
                /> */}
                </div>

                {/* <Select
                dropdownHeight="200px"
                options={dropdownData[DROPDOWNTYPES.BUSINESS_MODEL] || []}
                onChange={(values: any) => {
                  if (values?.length > 0) {
                    handleArrayValueChange(values, "business_models");
                  }
                }}
                labelField="label"
                valueField="value"
                name="business_models"
                values={
                  financeDetails?.business_model
                    ? [
                      {
                        value: financeDetails?.business_model,
                        label: financeDetails?.business_model,
                      },
                    ]
                    : []
                }
              /> */}
                {/* <ErrorComponent
                title="Please select business model"
                flag={errorFlag}
                isArray={true}
                data={financeDetails?.business_models}
              /> */}
              </Col>
              <Col lg={12} className="mb-2">
                <RequiredLabel isRequired={true} infoMultiple>
                  Preferred Investment Stages(max 3)
                </RequiredLabel>
                <div ref={controlRef1}>
                  <Select1
                    classNamePrefix="react-select"
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 999999 }),
                    }}
                    menuPortalTarget={document.body}
                    menuIsOpen={menuOpen1}
                    onMenuOpen={() => setMenuOpen1(true)}
                    onMenuClose={() => setMenuOpen1(false)}
                    closeMenuOnScroll={false}
                    className={
                      isWarning(fields_to_improve, "preferred_investment_stages")
                        ? "warning-field"
                        : ""
                    }
                    menuPosition="fixed"
                    options={
                      dropdownData[DROPDOWNTYPES.PREFERRED_INVESTMENT_STAGES] ||
                      []
                    }
                    isMulti
                    menuPlacement="bottom"
                    onChange={(values: any) => {
                      if (values?.length > 3) {
                        // toast(<CustomToast message="You can select a maximum of 3 options." type="warn" />);
                        toast.warn("You can select a maximum of 3 options.");
                        return false;
                      } else
                        handleArrayValueChange(
                          values,
                          "preferred_investment_stages",
                        );
                    }}
                    name="preferred_investment_stages"
                    value={
                      financeDetails?.preferred_investment_stages?.length > 0
                        ? financeDetails?.preferred_investment_stages.map(
                          (item: any) => ({
                            value: item?.title,
                            label: item?.title,
                          }),
                        )
                        : []
                    }
                  />
                </div>

                <ErrorComponent
                  title="Please select preferred investment stages"
                  flag={errorFlag}
                  isArray={true}
                  data={financeDetails?.preferred_investment_stages}
                />
              </Col>
              <Col lg={6} className="mb-2">
                <RequiredLabel isRequired={false}>
                  Level of Involvement Desired
                </RequiredLabel>
                <Select
                  dropdownHeight="200px"
                  options={dropdownData[DROPDOWNTYPES.LEVEL_OF_INVOLVEMENT] || []}
                  onChange={(values: any) => {
                    if (values?.length > 0) {
                      handleArrayValueChange(values, "level_of_involvement");
                    }
                  }}
                  labelField="label"
                  valueField="value"
                  className={
                    isWarning(fields_to_improve, "level_of_involvement")
                      ? "warning-field"
                      : "multi-select"
                  }
                  name="level_of_involvement"
                  values={
                    financeDetails?.level_of_involvement
                      ? [
                        {
                          value: financeDetails?.level_of_involvement,
                          label: financeDetails?.level_of_involvement,
                        },
                      ]
                      : []
                  }
                />
                {/* <ErrorComponent
                title="Please select desired level of involvement"
                flag={errorFlag}
                isArray={true}
                data={financeDetails?.level_of_involvement}
              /> */}
              </Col>
              <Col lg={6} className="mb-2">
                <RequiredLabel isRequired={true}>
                  Typical Investment Range
                </RequiredLabel>
                <Select
                  className={
                    isWarning(fields_to_improve, "typical_investment_range")
                      ? "warning-field"
                      : "multi-select"
                  }
                  dropdownHeight="200px"
                  options={
                    dropdownData[DROPDOWNTYPES.TYPICAL_INVESTMENT_RANGE] || []
                  }
                  onChange={(values: any) => {
                    if (values?.length > 0) {
                      handleArrayValueChange(values, "typical_investment_range");
                    }
                  }}
                  labelField="label"
                  valueField="value"
                  name="typical_investment_range"
                  values={
                    financeDetails?.typical_investment_range
                      ? [
                        {
                          value: financeDetails?.typical_investment_range,
                          label: financeDetails?.typical_investment_range,
                        },
                      ]
                      : []
                  }
                />
                <ErrorComponent
                  title="Please select typical investment range"
                  flag={errorFlag}
                  isArray={true}
                  data={financeDetails?.typical_investment_range}
                />
              </Col>
              <Col lg={6} className="mb-2">
                <RequiredLabel isRequired={false}>
                  Investment Instruments
                </RequiredLabel>
                <Select
                  dropdownHeight="200px"
                  options={
                    dropdownData[DROPDOWNTYPES.INVESTMENT_INSTRUMENTS] || []
                  }
                  onChange={(values: any) => {
                    if (values?.length > 0) {
                      handleArrayValueChange(values, "investment_instruments");
                    } else {
                      handleArrayValueChange([], "investment_instruments");
                    }
                  }}
                  className={
                    isWarning(fields_to_improve, "investment_instruments")
                      ? "warning-field"
                      : "multi-select"
                  }
                  clearable={
                    financeDetails?.investment_instruments !== "" &&
                    financeDetails?.investment_instruments !== null
                  }
                  labelField="label"
                  valueField="value"
                  name="investment_instruments"
                  values={
                    financeDetails?.investment_instruments
                      ? [
                        {
                          value: financeDetails?.investment_instruments,
                          label: financeDetails?.investment_instruments,
                        },
                      ]
                      : []
                  }
                />
                {/* <ErrorComponent
                title="Please select investment instruments"
                flag={errorFlag}
                isArray={true}
                data={financeDetails?.investment_instruments}
              /> */}
              </Col>
              <Col lg={6} className="mb-2">
                <RequiredLabel isRequired={false}>
                  Are You Associated With :
                </RequiredLabel>
                <Select
                  className={
                    isWarning(fields_to_improve, "associated_with")
                      ? "warning-field"
                      : "multi-select"
                  }
                  dropdownHeight="200px"
                  options={dropdownData[DROPDOWNTYPES.ASSOCIATED_WITH] || []}
                  onChange={(values: any) => {
                    if (values?.length > 0) {
                      handleArrayValueChange(values, "associated_with");
                    }
                  }}
                  clearable={
                    financeDetails?.associated_with !== "" &&
                    financeDetails?.associated_with !== null
                  }
                  labelField="label"
                  valueField="value"
                  name="associated_with"
                  values={
                    financeDetails?.associated_with
                      ? [
                        {
                          value: financeDetails?.associated_with,
                          label: financeDetails?.associated_with,
                        },
                      ]
                      : []
                  }
                />
                {/* <ErrorComponent
                title="Please select investment instruments"
                flag={errorFlag}
                isArray={true}
                data={financeDetails?.investment_instruments}
              /> */}
              </Col>
              <Col lg={12} className="mb-2">
                <RequiredLabel isRequired={true} infoMultiple>
                  Target Sectors / Domains (max 3)
                </RequiredLabel>
                <div ref={controlRef}>
                  <Select1
                    classNamePrefix="react-select"
                    className={
                      isWarning(fields_to_improve, "traget_domains")
                        ? "warning-field"
                        : ""
                    }
                    menuPosition="fixed"
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 999999 }),
                    }}
                    menuPortalTarget={document.body}
                    menuIsOpen={menuOpen}
                    onMenuOpen={() => setMenuOpen(true)}
                    onMenuClose={() => setMenuOpen(false)}
                    closeMenuOnScroll={false}
                    options={dropdownData[DROPDOWNTYPES.TRAGET_DOMAINS] || []}
                    isMulti
                    menuPlacement="bottom"
                    onChange={(values: any) => {
                      if (values?.length > 3) {
                        toast.warn("You can select a maximum of 3 options.");
                        return false;
                      } else handleArrayValueChange(values, "traget_domains");
                    }}
                    name="traget_domains"
                    value={
                      financeDetails?.traget_domains?.length > 0
                        ? financeDetails?.traget_domains.map((item: any) => ({
                          value: item?.title,
                          label: item?.title,
                        }))
                        : []
                    }
                  />
                </div>
                <ErrorComponent
                  title="Please select traget domains"
                  flag={errorFlag}
                  isArray={true}
                  data={financeDetails?.traget_domains}
                />
              </Col>
              <Col lg={12} className="mb-2">
                <RequiredLabel isRequired={false}>
                  Do You Prefer Confidential Matching or Public Listings?
                </RequiredLabel>
                <Select
                  dropdownHeight="200px"
                  options={dropdownData[DROPDOWNTYPES.PROFILE_VISIBILITY] || []}
                  onChange={(values: any) => {
                    if (values?.length > 0) {
                      handleArrayValueChange(values, "profile_visibility");
                    }
                  }}
                  clearable={
                    financeDetails?.profile_visibility !== "" &&
                    financeDetails?.profile_visibility !== null
                  }
                  labelField="label"
                  valueField="value"
                  name="profile_visibility"
                  className={
                    isWarning(fields_to_improve, "profile_visibility")
                      ? "warning-field"
                      : "multi-select"
                  }
                  values={
                    financeDetails?.profile_visibility
                      ? [
                        {
                          value: financeDetails?.profile_visibility,
                          label: financeDetails?.profile_visibility,
                        },
                      ]
                      : []
                  }
                />
                {/* <ErrorComponent
                title="Please select profile visibility"
                flag={errorFlag}
                isArray={true}
                data={financeDetails?.profile_visibility}
              /> */}
              </Col>
              <Col lg={12} className="mb-2">
                <RequiredLabel isRequired={false}>
                  Top Keywords for Matchmaking(Max 5)
                </RequiredLabel>
                <InfoIconForKeyword />

                <TagsInput
                  inputProps={{
                    placeholder: "Please hit ENTER to save keyword",
                    className: isWarning(fields_to_improve, "top_keywords")
                      ? "warning-field form-control react-tagsinput-input"
                      : "form-control react-tagsinput-input",
                  }}
                  value={
                    financeDetails?.top_keywords?.length > 0
                      ? financeDetails?.top_keywords?.map(
                        (ele: any) => ele?.title,
                      )
                      : []
                  }
                  className={
                    isWarning(fields_to_improve, "top_keyword")
                      ? "warning-field"
                      : "multi-select"
                  }
                  preventSubmit
                  addOnPaste
                  onlyUnique
                  onChange={(tags: string[]) => {
                    if (tags?.length > 5) {
                      toast.warn("Max 5 keywords allowed!");
                      return;
                    }
                    setFinanceDetails(
                      (prev: FinanceDetails_INVESTORInterface) => ({
                        ...prev,
                        top_keywords: tags.map((tag) => ({ title: tag })),
                      }),
                    );
                  }}
                />
                {/* <ErrorComponent
                title="Please enter at least one keyword"
                flag={errorFlag}
                isArray={true}
                data={financeDetails?.top_keywords}
              /> */}
              </Col>
              <Col className="mb-2" lg={12}>
                <RequiredLabel isRequired={false}>
                  Open to Co-Investment or Syndicates?
                </RequiredLabel>

                <div className="d-flex gap-3 mt-1 justify-content-start">
                  <div
                    className={`form-check warning-radio-wrapper ${isWarning(fields_to_improve, "open_syndicates")
                      ? "active-warning"
                      : ""
                      }`}
                  >
                    <input
                      className="form-check-input custom-checkbox"
                      type="radio"
                      name="open_syndicates"
                      id="yes"
                      value="1"
                      checked={
                        financeDetails?.open_syndicates === "1" ||
                        financeDetails?.open_syndicates === 1
                      }
                      onChange={(e) =>
                        setFinanceDetails(
                          (pre: FinanceDetails_INVESTORInterface) => ({
                            ...pre,
                            open_syndicates: e.target.value,
                          }),
                        )
                      }
                    />

                    <label className="form-check-label" htmlFor="yes">
                      Yes
                    </label>
                  </div>

                  <div
                    className={`form-check warning-radio-wrapper ${isWarning(fields_to_improve, "open_syndicates")
                      ? "active-warning"
                      : ""
                      }`}
                  >
                    <input
                      className={
                        isWarning(fields_to_improve, "open_syndicates")
                          ? "form-check-input custom-checkbox"
                          : "form-check-input"
                      }
                      type="radio"
                      name="open_syndicates"
                      id="no"
                      value="0"
                      checked={
                        financeDetails?.open_syndicates === "0" ||
                        financeDetails?.open_syndicates === 0
                      }
                      onChange={(e) =>
                        setFinanceDetails(
                          (pre: FinanceDetails_INVESTORInterface) => ({
                            ...pre,
                            open_syndicates: e.target.value,
                          }),
                        )
                      }
                    />
                    <label className="form-check-label" htmlFor="no">
                      No
                    </label>
                  </div>
                </div>
                {/* <ErrorComponent
                title="Please select "
                flag={errorFlag}
                isArray={false}
                data={financeDetails?.open_syndicates}
              /> */}
              </Col>
              <Col>
                <div className="mb-2">
                  <RequiredLabel isRequired={false}>
                    Do You Offer Global Market Access or Exit Support?
                  </RequiredLabel>
                  <div className="d-flex gap-3 mt-1">
                    {GLOBAL_MARKET_OPTIONS.map((item: any, index: number) => (
                      <div
                        className={`form-check warning-radio-wrapper ${isWarning(fields_to_improve, "global_market_support")
                          ? "active-warning"
                          : ""
                          }`}
                      >
                        <input
                          className={
                            isWarning(fields_to_improve, "global_market_support")
                              ? "warning-field form-check-input custom-checkbox "
                              : "form-check-input"
                          }
                          type="radio"
                          name="preferred_communication"
                          id={`index_${index}`}
                          value={item?.value}
                          checked={
                            financeDetails?.global_market_support?.toString() ===
                            item?.value
                          }
                          onChange={(e) =>
                            setFinanceDetails(
                              (pre: FinanceDetails_INVESTORInterface) => ({
                                ...pre,
                                global_market_support: item?.value,
                              }),
                            )
                          }
                        />
                        <label
                          className="form-check-label"
                          htmlFor={`index_${index}`}
                        >
                          {item?.label}
                        </label>
                      </div>
                    ))}
                  </div>
                  {/* <ErrorComponent
                  title="Please select preferred communication mode  "
                  flag={errorFlag}
                  isArray={false}
                  data={financeDetails?.global_market_support}
                /> */}
                </div>
              </Col>
            </Row>
            {from && from === "REVIEW" ? null : (
              <div>
                <div className="form-check mb-0">
                  <input
                    className={
                      errorFlag && !checked1
                        ? "custom-checkbox form-check-input"
                        : "form-check-input"
                    }
                    type="checkbox"
                    value=""
                    id="flexCheckDefault"
                    checked={checked1}
                    onChange={() => setChecked1(!checked1)}
                  />
                  <label
                    className="form-check-label pb-0"
                    htmlFor="flexCheckDefault"
                  >
                    <span className="checkbox-title">
                      {" "}
                      I have read and agree to the{" "}
                      <a
                        href="https://theprimeshark.com/terms-of-use/"
                        target="_blank"
                        rel="noopener noreferrer"
                        onClick={(e) => e.stopPropagation()}
                      >
                        terms and conditions
                      </a>
                    </span>
                  </label>
                </div>
              </div>
            )}
            {from && from === "REVIEW" ? null : (
              <div>
                <div className="form-check mb-4">
                  <input
                    className={
                      errorFlag && !checked2
                        ? "custom-checkbox form-check-input"
                        : "form-check-input"
                    }
                    type="checkbox"
                    value=""
                    id="flexCheckDefault1"
                    checked={checked2}
                    onChange={() => setChecked2(!checked2)}
                  />
                  <label
                    className="form-check-label pb-0"
                    htmlFor="flexCheckDefault1"
                  >
                    <span className="checkbox-title">
                      {" "}
                      I give my consent to the processing of my personal data,
                      including for AI matchmaking, in line with the{" "}
                      <a
                        href="https://theprimeshark.com/privacy-policy/"
                        target="_blank"
                        rel="noopener noreferrer"
                        onClick={(e) => e.stopPropagation()}
                      >
                        Privacy Policy
                      </a>.
                    </span>
                  </label>
                </div>
              </div>
            )}

            <div className="mb-2 d-flex gap-2">
              <Button
                className={
                  from === "REVIEW" || from === "FROM_PROFILE_ANALYSIS"
                    ? "btn btn-primary w-100"
                    : "btn btn-primary w-50"
                }
                disabled={apiCallTriggered}
                type="button"
                id="save_finance_details"
                onClick={() => handleContinue(false)}
              >
                {from && from === "REVIEW" ? "Save" : "Continue"}
              </Button>
              {from !== "REVIEW" && from !== "FROM_PROFILE_ANALYSIS" && (
                <Button
                  className="btn btn-secondary w-50"
                  type="button"
                  id="skip_finance_details"
                  onClick={() => {
                    handleContinue(true);
                  }}
                  disabled={apiCallTriggered}
                >
                  Skip
                </Button>
              )}
            </div>
          </div>{" "}
        </CommonScrollbar>
        {show && (
          <SuccessPopup
            show={show}
            msg="Investor profile registered successfully!"
            id="register_success_id"
          />
        )}
      </div>
    </>
  );
};
export default FinanceDetails_INVESTOR;
